import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {MessageService} from './message.service';
import {Message, MessageTypes} from './message';

// https://angular.io/guide/router#teach-authguard-to-authenticate
@Injectable()
export class AuthenticationService {
    public sessionID;
    isLoggedin = false;
    // isLoggedin = true;
    domain: string;

    constructor(private http: HttpClient, private router: Router, private messageService: MessageService) {
        this.domain = '/api';
        this.checkAuthentication();
    }

    public checkAuthentication() {
        const apiCall = this.http.get(this.domain + '/authenticate/check');
        const promise = apiCall.toPromise();
        try {
            promise.then((val) => {
                    if (val !== false) {
                        this.sessionID = val;
                        this.isLoggedin = true;
                    } else {
                        this.isLoggedin = false;
                    }
                },
                () => {
                    this.isLoggedin = false;
                }
            );
        } catch (e) {
            console.log('error when trying to authenticate: ', e);
        }
        return promise;
    }

    public authenticate(username, password) {
        const subscription = this.http.get(
            this.domain + '/authenticate/' + encodeURIComponent(username) + '/' + encodeURIComponent(password)
        )
            .subscribe((val) => {
                    this.isLoggedin = true;
                    this.sessionID = val;
                    this.router.navigate(['/dashboard']);
                },
                () => {
                    this.messageService.setMessage('Login failed - please check your username and password', MessageTypes.Error);
                    // console.log('log in failed');
                    // this.isLoggedin = false;
                }
            );
        return subscription;
    }

    public signout() {
        const request = this.http.get(this.domain + '/logout');
        const promise = request.toPromise();
        this.isLoggedin = false;
        return promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/authentication.service.ts